// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import Heading, { HeadingPresentationProps } from "@store/Library/Components/Toolkit/Heading";
import LinkBack, { LinkBackPresentationProps, LinkBackProps } from "@store/Library/Components/Toolkit/LinkBack";
import useExpandProps, { ExpandStyles } from "@toolkit/Framework/Common/Hooks/useExpandProps";
import useZoneIsActive from "@toolkit/Framework/Common/Hooks/useZoneIsActive";
import breakpointValues from "@toolkit/Framework/Common/Utilities/breakpointValues";
import { pxToRemArray } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { spacingStyles } from "@toolkit/Themes/common/mixins";
import React, { FC, ReactNode } from "react";
import { css } from "styled-components";

const zoneName = "Message";

const wrapperStyles = () => css`
    ${x => spacingStyles(x.theme.design.typography.spacing.large, x.theme.design.typography.spacing.small)}

    && + .message {
        margin-top: 0;
    }
`;

export interface OrderHeaderProps extends ExpandStyles<OrderHeaderStyles> {
    contentId?: string;
    title: string;
    message?: string | ReactNode;
    linkBack?: LinkBackProps["pageLink"];
    linkBackOnClick?: LinkBackProps["onClick"];
}

export interface OrderHeaderStyles {
    wrapper?: InjectableCss;
    heading?: HeadingPresentationProps;
    messageWrapper?: InjectableCss;
    zoneWrapper?: InjectableCss;
    linkBack?: LinkBackPresentationProps;
}

export const orderHeaderStyles: OrderHeaderStyles = {
    wrapper: {
        css: css`
            ${x => breakpointValues(x.theme.design.layout.spacing.narrowContent, "margin-bottom")}

            &:last-child {
                margin-bottom: 0;
            }
        `,
    },
    heading: {
        variant: "headerPrimary", // Kishigo
        extendedStyles: {
            title: {
                css: css`
                    margin: 0;
                    border-bottom: 4px solid ${getColor("common.border")};
                    ${breakpointValues(pxToRemArray([16, null, 20, null, 24]), "padding-bottom")}
                `,
            },
        },
    },
    messageWrapper: {
        css: wrapperStyles(),
    },
    zoneWrapper: {
        css: wrapperStyles(),
    },
};

const OrderHeader: FC<OrderHeaderProps> = ({
    children,
    extendedStyles,
    overridedStyles,
    title,
    contentId,
    message,
    linkBack,
    linkBackOnClick,
}) => {
    const styles = useExpandProps(orderHeaderStyles, extendedStyles, overridedStyles);
    const zoneIsActive = useZoneIsActive(contentId || "", zoneName);

    return (
        <StyledWrapper {...styles.wrapper}>
            <LinkBack pageLink={linkBack} onClick={linkBackOnClick} {...styles.linkBack} />
            <Heading title={title} {...styles.heading}>
                {children}
            </Heading>
            {message ? (
                <StyledWrapper {...styles.messageWrapper} className="message">
                    {message}
                </StyledWrapper>
            ) : null}
            {contentId && zoneIsActive ? (
                <StyledWrapper {...styles.zoneWrapper} className="message">
                    <Zone contentId={contentId} zoneName={zoneName} />
                </StyledWrapper>
            ) : null}
        </StyledWrapper>
    );
};

export default OrderHeader;
